import { m } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Cable, Cctv, Flame, Wrench, Siren } from "lucide-react";
import { SERVICES, BUSINESS } from "@/data/site";

const ease = [0.22, 1, 0.36, 1];

const ICONS = {
  rewires: Cable,
  cctv: Cctv,
  "fire-alarms": Flame,
  "fault-finding": Wrench,
  emergency: Siren,
};

export const Services = () => (
  <section id="services" className="relative py-24 lg:py-36 border-t border-hairline">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16 lg:mb-20">
        <div className="lg:col-span-7">
          <p className="font-mono text-xs tracking-[0.25em] text-brand mb-6 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-brand" />
            OUR SERVICES
          </p>
          <h2 className="font-heading uppercase leading-[0.9] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-stark">
            Every job,<br />done properly.
          </h2>
        </div>
        <p className="lg:col-span-5 text-concrete leading-relaxed">
          From a single faulty socket to a full commercial fit-out, {BUSINESS.name} covers all common
          electrical work across {BUSINESS.region}. No job too big or small.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.id] || Cable;
          return (
            <m.div
              key={s.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, ease, delay: (i % 3) * 0.08 }}
            >
              <Link
                to={`/${s.slug}`}
                data-testid={`service-${s.id}`}
                className="glossy-card group flex h-full flex-col p-7 lg:p-8"
              >
                <div className="flex items-start justify-between">
                  <span className="glossy-icon grid place-items-center w-14 h-14 rounded-2xl shrink-0">
                    <Icon className="w-7 h-7 text-white" strokeWidth={2} />
                  </span>
                  <span className="font-mono text-xs tracking-[0.2em] text-white/40 pt-1">{s.num}</span>
                </div>

                <h3 className="font-heading uppercase tracking-tight text-2xl lg:text-3xl text-white mt-7 leading-[0.95]">
                  {s.title}
                </h3>

                <p className="text-sm text-blue-100/70 leading-relaxed mt-3 flex-1">
                  {s.blurb}
                </p>

                <span className="mt-7 inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] text-[#4DA3FF] group-hover:gap-3 transition-all duration-300">
                  LEARN MORE
                  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </m.div>
          );
        })}
      </div>
    </div>
  </section>
);
